import {Icon} from '@github-ui/pacer/Icon'
import {TriangleDownIcon} from '@primer/octicons-react'
import type React from 'react'

import {Pill} from './Pill'

type StarterPillProps = Omit<React.ComponentProps<typeof Pill>, 'children' | 'icon'> & {
  testId: string
  name: string
  icon: string
  color: string
  onClick: () => void
  dropdown?: boolean
  open?: boolean
  ref?: React.Ref<HTMLButtonElement>
}

export const StarterPill = ({ref, testId, name, icon, color, onClick, dropdown, open, ...rest}: StarterPillProps) => (
  <Pill
    {...rest}
    ref={ref}
    onClick={onClick}
    aria-expanded={open}
    data-testid={`starter-${testId}`}
    leadingVisual={icon ? <Icon icon={icon} color={color} /> : undefined}
    trailingAction={dropdown ? TriangleDownIcon : undefined}
  >
    {name}
  </Pill>
)

StarterPill.displayName = 'StarterPill'
